import ReactDOM from 'react-dom';
import React, { Component, useEffect, useState } from 'react';
import { component } from 'picoapp'
import { QueryClient, QueryClientProvider, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { motion, AnimatePresence, useAnimation } from 'framer-motion';
import jump from 'jump.js';

import { questionsArray, results } from '../Quiz/API';
import Question from '../Quiz/Question';
import AssessmentResults from '../Quiz/AssessmentResults';
import Sugestions from '../Quiz/Sugestions';

import LoadingSpinner from '../../parts/LoadingSpinner';

import '../Quiz/style.scss'


const queryClient = new QueryClient();

const HomeQuizHero = ({ appstate, node }) => {

  return (
    <QueryClientProvider client={queryClient}>
      <Quiz appstate={appstate} node={node} />
    </QueryClientProvider>
  )
}

const Quiz = ({ appstate, node }) => {
  const [isLoading, setIsLoading] = useState(true);

  const [questions, setQuestions] = useState(questionsArray);
  const [questionIndex, setQuestionIndex] = useState(0)
  const [answers, setAnswers] = useState({});
  const [recomendations, setRecomendations] = useState()
  const [hasRecomendations, setHasRecomendations] = useState(false)
  const [assessmentCompleted, setAssessmentCompleted] = useState(false)


  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
      document.body.dispatchEvent(new Event('quizLoaded'));
    }, 1000);
  }, [])

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  }, [isLoading])

  const handleSelection = (e) => {
    if (e.target.name == 'plan') {

      const value = e.target.value == 'Mostly Down' ? e.target.value : e.target.value.split(', ');
      const has_multiple = value == 'Mostly Down' ? false : true;
      const plan = answers.plan ? [...answers.plan] : [];

      if (!has_multiple) {
        if (e.target.checked && !plan.includes(value)) {
          plan.push(value)
        } else if (!e.target.checked && plan.includes(value)) {
          plan.splice(plan.indexOf(value), 1);
        }
      } else {
        if (e.target.checked && !value.every(o => plan.includes(o))) {
          plan.push(...value)
        } else if (!e.target.checked && value.every(o => plan.includes(o))) {
          value.forEach(v => plan.splice(plan.indexOf(v), 1))
        }
      }

      setAnswers({ ...answers, plan: plan })
    } else if (e.target.name == 'goals' && e.target.value == 'Volume & Length') {
      //VOLUME & LENGTH SHOWS SAME RESULTS AS JUST LENGTH
      setAnswers({ ...answers, goals: "Length" })
    } else {
      setAnswers({ ...answers, [e.target.name]: e.target.value })
    }
    if (e.target.name == "plan") {

    } else {
      setQuestionIndex(questionIndex + 1)
    }
  }

  const fetchProducts = async (handles) => {
    const products = []
    for (let handle of handles) {
      const { data } = await axios.get(`/products/${handle}.js`, { headers: { Pragma: 'no-cache' } });
      products.push(data);
    }

    setRecomendations(products);
    setAssessmentCompleted(true);
  }

  const handleResults = (e) => {
    e.preventDefault();
    jump(node, {
      duration: 100,
      offset: -100
    })
    setIsLoading(true)
    const productHandles = [];
    const flatAnswers = Object.values(answers).flat()
    results.forEach(r => {
      r.possibleAnswers.forEach(p => {
        if (p.every(p => flatAnswers.includes(p))) {
          productHandles.push(r.productHandle)
        }
      })
    });
    const uniqueHandles = [...new Set(productHandles)];

    fetchProducts(uniqueHandles)

    //GA QUIZ TRACKING
    ga('set', 'dimension1', answers['hair-type']);
    ga('set', 'dimension2', answers['thickness']);
    ga('set', 'dimension3', answers['length']);
    ga('set', 'dimension4', answers['goals']);
    ga('set', 'dimension5', answers['plan']);
    ga('send', 'event', 'Quiz', 'Completed', 'Home Hero Quiz');
  }

  useEffect(() => {
    if (assessmentCompleted) {
      setTimeout(() => {
        setIsLoading(false)
      }, 1000);
    }
  }, [assessmentCompleted])

  useEffect(() => {
    if (recomendations?.length) {
      setHasRecomendations(true)
    }
  }, [recomendations])

  const resetQuiz = () => {
    setQuestionIndex(0)
    setAnswers({})
    setRecomendations(null)
    setAssessmentCompleted(false);
    jump(node, {
      duration: 100,
      offset: -100
    })
  }

  if (isLoading) {
    return (
      <LoadingSpinner></LoadingSpinner>
    )
  }

  const animVariants = {
    initial: { x: "100%", opacity: 0, transition: { duration: 1 } },
    start: { x: 0, opacity: 1, transition: { duration: 1 } },
    exit: { x: "-100%", opacity: 0, transition: { duration: 0.5, delay: 0.5 } },
  }

  return (
    <>
      {!assessmentCompleted
        ? <AnimatePresence exitBeforeEnter>
          <motion.div
            initial={questionIndex == 0 ? 'start' : 'initial'}
            animate={'start'}
            key={questions[questionIndex].value}
            exit={'exit'}
            transition={{ ease: "easeOut" }}
            variants={animVariants}>
            <Question
              value={questions[questionIndex].value}
              options={questions[questionIndex].options}
              title={questions[questionIndex].title}
              handleSelection={handleSelection}
            />
          </motion.div>
        </AnimatePresence>
        : <>
          {/* <AssessmentResults answers={answers} /> */}
          {hasRecomendations
            ? <Sugestions products={recomendations} />
            : <div className="Section Section--noResults">
              <div className="Section__header">
                <h4 className="heading"> No matches found</h4>
              </div>
              <div className="Section__content">
                <button type="Button" className="Button" data-style="solid pink" onClick={resetQuiz}>Restart Quiz</button>
              </div>
            </div>
          }
        </>
      }
      {!assessmentCompleted && Object.keys(answers).length == 5 && answers.plan.length > 0 &&
        <div className="Quiz-cta">
          <button type="button" className="Button" data-style="solid pink" onClick={handleResults}>See Results</button>
        </div>
      }
    </>
  )

}

export default component((node, ctx) => {
  const element = <HomeQuizHero appstate={ctx} node={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
